module.exports = __webpack_public_path__ + "static/media/s2.9a03334d.png";